import { Typography, styled } from '@mui/material';

export const Divider = styled('hr')(({ theme }) => ({
  borderColor: theme.mainTextSecondary,
  marginBottom: theme.spacing(2),
  marginTop: 0,
  width: '100%',
}));

export const SectionContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    paddingTop: theme.spacing(2),
  },
}));

export const SectionHeading = styled(Typography)(() => ({
  fontFamily: '"Roboto Condensed", sans-serif',
  fontWeight: 'bold',
}));
